import { getCount } from '@/features/AudienceManager/services';
export const fetchCount = (query, audienceId) => {
    return getCount(query, audienceId).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        success: response?.success,
        errors: response?.errors,
        data: {
            count: response?.data?.count,
            score: response?.data?.score,
            token: response?.data?.token,
        },
    };
};
